<template>
    <div>
        <Head title="گروه رژیم درمانی بادوم" />
        <div class="d-flex flex-wrap">
            <div class="col-12 col-lg-6 vh d-flex align-content-center justify-content-center py-5 order-2  order-lg-1">
                <div class="my-auto ">
                    <h1 class="line-height text-white text-lg text-center text-md-end">
                        گروه بادام همراه شما تا رسیدن به وزن ایده آل با رژیم های تخصصی و همراهی کارشناسان و مشاوران
                        تغذیه و
                        روانشناسی فاصله ای تا تناسب اندام نخواهید داشت
                    </h1>
                    <div class="mt-5 text-center text-md-end">
                        <Link class="btn btn-orange" href="/physical-information">دریافت رژیم و شروع سلامتی</Link>
                    </div>

                </div>
            </div>
            <div class="col-12 col-lg-6 order-1 order-lg-2 position-absolute-left px-0">
                <div class="background__index-left">
                    <img class="img-fluid px-2 px-md-4" src="/front/assets/images/2979352.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import LayoutIndex from "../Shared/Layouts/LayoutIndex";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    props : {menu : Object},
    components: {
        Head,Link
    },
    layout: LayoutIndex,
    metaInfo() {
        return {
            meta : [
                {name : 'description' , content : 'hello is my desd' , title : 'sa'}
            ]
        }

    }
}
</script>

<style scoped>

</style>
